/**
 *  Actor
 *
 *  Created by Legman on 22/02/2017.
 *
 */

/**
 * @class
 */
export default class Actor extends PIXI.Container {
    /**
     * @param {PIXI.Texture} [texture]
     * @constructor
     */
    constructor(texture) {
        super();

        texture = texture || PIXI.Texture.EMPTY;

        /**
         * @member {PIXI.Sprite | PIXI.spine.Spine}
         */
        if (texture) {
            this.view = new PIXI.Sprite(texture);
            this.view.anchor = new PIXI.Point(0.5, 0.5);
            this.addChild(this.view);
        }

        /**
         * @member {boolean}
         */
        this.destroyNextFrame = false;

        this.on("added", this.init, this);
    }

    init() {
        this.off("added", this.init);
    }

    /**
     * @param {boolean} [destroyChildren]
     */
    destroy(destroyChildren) {
    }

    update() {
    }

    /**
     * @returns {PIXI.Container}
     */
    get spine() {
        return this.view;
    }

    /**
     * @param {PIXI.Container} value
     */
    set spine(value) {
        this.view = value;
    }
}
